export default __webpack_public_path__ + "static/Red-Hot-Gloss-Homepage-Banner-Mobile-W1-a33be85f004d8f9ac26f4214a827bc5c.webp";